












































import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import PickupSelectCard from '@/components/common/PickupSelectCard.vue';
import { MerchantDetailsModel } from '@/models/MerchantDetailsModel';

@Component({
  components: { PickupSelectCard },
})
export default class PickupSelect extends Vue {
  private showTimePopover = false;

  private get merchant(): MerchantDetailsModel {
    return this.$store.state.merchant.merchant;
  }

  private get pickupDateTime(): moment.Moment | null {
    return this.$store.state.cart.pickupDateTime;
  }

  private get formattedPickupTime(): string | null {
    if (!this.pickupDateTime) {
      return null;
    }
    const pickupDateTime = this.pickupDateTime.clone().tz(this.merchant?.timezone);
    const time = this.pickupDateTime.isAsapTime ? 'ASAP' : pickupDateTime.format('hh:mm A');

    return `${pickupDateTime.format('ddd, MMM D')} @ ${time}`;
  }
}
